import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'shared/components/Text/Text';
import styled from 'styled-components';

const Section = styled.div`
  margin-bottom: 24px;
`;

const SectionTitle = styled(Text)`
  font-weight: 700;
  margin-bottom: 8px;
`;

const SectionBody = styled(Text)`
  margin-bottom: 12px;
`;

export function TransferInfoDrawerContent() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'support&FAQs.faqCategories.agreementTransferStatus.infoDrawer',
  });

  return (
    <div>
      <Section>
        <SectionTitle as="h4">{t('creditApplication.title')}</SectionTitle>
        <SectionBody as="p">{t('creditApplication.body1')}</SectionBody>
        <SectionBody as="p">{t('creditApplication.body2')}</SectionBody>
      </Section>

      <Section>
        <SectionTitle as="h4">{t('signAgreement.title')}</SectionTitle>
        <SectionBody as="p">{t('signAgreement.body1')}</SectionBody>
        <SectionBody as="p">{t('signAgreement.body2')}</SectionBody>
      </Section>

      <Section>
        <SectionTitle as="h4">{t('finalizing.title')}</SectionTitle>
        <SectionBody as="p">{t('finalizing.body1')}</SectionBody>
        <SectionBody as="p">{t('finalizing.body2')}</SectionBody>
      </Section>
    </div>
  );
}

export default TransferInfoDrawerContent;
